import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createChannel = createAsyncThunk("createChannel", async (values, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`channel`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CreateChannelSlice = createSlice({
	name: "CreateChannelSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateChannelState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createChannel.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createChannel.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createChannel.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateChannelState } = CreateChannelSlice.actions;
export default CreateChannelSlice.reducer;
